"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var loaders_css_component_1 = require("./loaders-css.component");
var LoadersCssModule = (function () {
    function LoadersCssModule() {
    }
    return LoadersCssModule;
}());
LoadersCssModule.decorators = [
    { type: core_1.NgModule, args: [{
                imports: [common_1.CommonModule],
                declarations: [loaders_css_component_1.LoadersCssComponent],
                exports: [loaders_css_component_1.LoadersCssComponent],
                providers: []
            },] },
];
/** @nocollapse */
LoadersCssModule.ctorParameters = function () { return []; };
exports.LoadersCssModule = LoadersCssModule;
//# sourceMappingURL=module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-loaders-css/module/module.js
// module id = 183
// module chunks = 3